import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ApiParams } from '@/core/http/ApiResource';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { Partner, usePartner } from '@/modules/partner/Partner';
import auth from '@/core/Auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = usePartner();
const defaultParams: ApiParams = {};
const partnerToDelete = ref<Partner>();
const canCreate = ref<boolean>(auth.can('PARTNER'));

const columns = [
	new Column<Partner>($gettext('Namn'), 'name', 'name', '+'),
	new Column<Partner>($gettext('Organisationsnummer'), 'identity_number', 'identity_number'),
	new Column<Partner>($gettext('Telefonnummer'), 'phone', 'phone'),
	new Column<Partner>($gettext('E-postadress'), 'email', 'email'),
];

const actionColumn = new ActionColumn<Partner>()
	.withLink(
		'palette',
		't-neutral',
		(p: Partner) => ({ name: 'partner.whitelabel', params: { id: p.id } }),
	)
;

if (auth.can('PARTNER')) {
	actionColumn
		.withLink(
			'users',
			't-neutral',
			(p: Partner) => ({ name: 'partner.user.index', params: { partner_id: p.id } }),
		)
		.withLink(
			'handshake-alt',
			't-neutral',
			(p: Partner) => ({ name: 'partner.law_firm', params: { id: p.id } }),
		)
		.withEditLink((lf) => ({ name: 'partner.edit', params: { id: lf.id } }))
		.withDeleteLink((lf: Partner) => {
			partnerToDelete.value = lf;
		})
	;
}

columns.push(actionColumn);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Återförsäljare')
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "default-params": defaultParams,
          "delete-title": _unref($gettext)('Ta bort återförsäljare'),
          "delete-name-key": "name",
          "to-delete": partnerToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((partnerToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 2
  }, [
    (canCreate.value)
      ? {
          name: "header-actions",
          fn: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
              to: {name: 'partner.create'},
              class: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ny återförsäljare ")
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_translate]
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title"]))
}
}

})